import { render, staticRenderFns } from "./Consolidacao.vue?vue&type=template&id=1829e935&"
import script from "./Consolidacao.vue?vue&type=script&lang=js&"
export * from "./Consolidacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports